// src/api/api.js
import axios from 'axios';

// Use relative URL for production; absolute URL for development
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

// Optionally, add a request interceptor to attach tokens
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// **Define getUsers Function**
export const getUsers = (params = {}) => {
  return api.get('/auth/users', { params });
};

export default api;

